var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpRightArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_468_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9716 0.5H2.87804C2.30915 0.5 1.84654 0.962613 1.84654 1.5315C1.84654 2.10039 2.30915 2.563 2.87804 2.563H12.4773L0.302417 14.741C-0.100806 15.1442 -0.100806 15.7975 0.302417 16.2007C0.70564 16.6039 1.35892 16.6039 1.76215 16.2007L13.937 4.02273V13.6219C13.937 14.1908 14.3996 14.6534 14.9685 14.6534C15.5374 14.6534 16 14.1908 16 13.6219V1.5315C16.0031 0.962613 15.5405 0.5 14.9716 0.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_468_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpRightArrowWhite);
export default __webpack_public_path__ + "static/media/up-right-arrow-white.a4b62d624957d0429658e250cf8dbec4.svg";
export { ForwardRef as ReactComponent };